import { Reveal } from "../components/Reveal";
import { COMPANY } from "../data/site";

const LegalShell = ({ title, overline, children, testId }) => (
  <main data-testid={testId}>
    <section className="border-b border-line">
      <div className="mx-auto max-w-[1600px] px-6 pb-16 pt-40 md:px-12 md:pt-52">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember">{overline}</p>
          <h1 className="mt-8 font-display text-4xl font-black uppercase tracking-tighter text-bone md:text-7xl">{title}</h1>
        </Reveal>
      </div>
    </section>
    <section className="mx-auto max-w-[900px] px-6 py-20 md:px-12">
      <Reveal className="space-y-14">{children}</Reveal>
    </section>
  </main>
);

const Block = ({ heading, children, testId }) => (
  <div data-testid={testId}>
    <h2 className="font-display text-xl font-semibold uppercase tracking-tight text-ember">{heading}</h2>
    <div className="mt-5 space-y-4 text-sm leading-relaxed text-ash">{children}</div>
  </div>
);

export const Impressum = () => (
  <LegalShell title="Impressum" overline="Rechtliches" testId="impressum-page">
    <Block heading="Angaben gemäß § 5 TMG" testId="impressum-company">
      <p>
        {COMPANY.name}<br />
        Inh. R. Sylka<br />
        {COMPANY.street}<br />
        {COMPANY.city}
      </p>
    </Block>
    <Block heading="Kontakt" testId="impressum-contact">
      <p>
        Telefon: <a href={COMPANY.phoneHref} className="text-bone transition-colors duration-300 hover:text-ember">{COMPANY.phone}</a><br />
        E-Mail: <a href={COMPANY.emailHref} className="text-bone transition-colors duration-300 hover:text-ember">{COMPANY.email}</a>
      </p>
    </Block>
    <Block heading="Steuernummer" testId="impressum-tax">
      <p>Steuer-Nr.: {COMPANY.tax}</p>
    </Block>
    <Block heading="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV" testId="impressum-responsible">
      <p>
        R. Sylka<br />
        {COMPANY.street}<br />
        {COMPANY.city}
      </p>
    </Block>
    <Block heading="Haftung für Inhalte" testId="impressum-liability">
      <p>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
      </p>
    </Block>
  </LegalShell>
);

export const Datenschutz = () => (
  <LegalShell title="Datenschutz" overline="Rechtliches" testId="datenschutz-page">
    <Block heading="1. Verantwortliche Stelle" testId="datenschutz-responsible">
      <p>
        {COMPANY.name}, Inh. {COMPANY.owner}, {COMPANY.street}, {COMPANY.city}<br />
        Telefon: {COMPANY.phone} — E-Mail: {COMPANY.email}
      </p>
    </Block>
    <Block heading="2. Erhebung und Verarbeitung von Daten" testId="datenschutz-collection">
      <p>
        Beim Besuch dieser Website werden durch den Hosting-Anbieter automatisch Informationen in sogenannten Server-Log-Dateien gespeichert (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp). Diese Daten dienen der technischen Bereitstellung und Sicherheit der Website und werden nicht mit anderen Datenquellen zusammengeführt.
      </p>
    </Block>
    <Block heading="3. Kontaktformular" testId="datenschutz-form">
      <p>
        Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben (Name, E-Mail-Adresse, ggf. Telefonnummer, Gewerk und Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung Ihrer Anfrage).
      </p>
    </Block>
    <Block heading="4. Ihre Rechte" testId="datenschutz-rights">
      <p>
        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der oben angegebenen Adresse an uns wenden. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
      </p>
    </Block>
    <Block heading="5. Cookies und Analyse" testId="datenschutz-cookies">
      <p>
        Diese Website verwendet keine Tracking-Cookies und keine Analyse-Tools von Drittanbietern.
      </p>
    </Block>
  </LegalShell>
);
